const ErrorMessage = ({ message }) => {
    return (
        <div style={styles.container}>
            <h3 style={styles.title}>⚠️ Error</h3>
            <p style={styles.message}>{message || 'Something went wrong. Please try again.'}</p>
        </div>
    );
};

const styles = {
    container: {
        backgroundColor: '#fee',
        border: '1px solid #fcc',
        borderRadius: '8px',
        padding: '20px',
        margin: '20px 0',
        textAlign: 'center',
    },
    title: {
        color: '#c33',
        marginBottom: '10px',
    },
    message: {
        color: '#666',
    },
};

export default ErrorMessage;